export default __webpack_public_path__ + "static/media/cross_black.3107cfc1.svg";